import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import ReactSelect from "../../UI/ReactSelectNotClear";
import FormControl from "@material-ui/core/FormControl";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
const initialValues = {
  device: "",
  finger: "",
  hand: "",
};

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}
TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default function Create(props) {
  const {
    show,
    onHide,
    chooseSapId,
    onSapChoose,
    onSaps,
    filterInputs,
    deviceId,
    orderBy,
    sortField,
    skip,
    take,
  } = props;

  const [isError, setIsError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingRegister, setIsLoadingRegister] = useState(false);

  const [deviceOption, setDeviceOption] = React.useState(null);
  const [value, setValue] = React.useState(0);
  const [fingerList, setFingerList] = useState([]);

  const [currentRadioValue, setCurrentRadioValue] = useState();

  useEffect(() => {
    onSapChoose(chooseSapId).then((res) => {
      setFingerList(res.data.employeeFingers);
    });
  }, [chooseSapId, onSapChoose]);

  const handleRadioChange = (e) => {
    setCurrentRadioValue(e.target.value);
  };

  const handleRadioChange0 = () => {
    setCurrentRadioValue("0");
  };
  const handleRadioChange1 = () => {
    setCurrentRadioValue("1");
  };
  const handleRadioChange2 = () => {
    setCurrentRadioValue("2");
  };
  const handleRadioChange3 = () => {
    setCurrentRadioValue("3");
  };
  const handleRadioChange4 = () => {
    setCurrentRadioValue("4");
  };
  const handleRadioChange5 = () => {
    setCurrentRadioValue("5");
  };
  const handleRadioChange6 = () => {
    setCurrentRadioValue("6");
  };
  const handleRadioChange7 = () => {
    setCurrentRadioValue("7");
  };
  const handleRadioChange8 = () => {
    setCurrentRadioValue("8");
  };
  const handleRadioChange9 = () => {
    setCurrentRadioValue("9");
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const CreateSchema = Yup.object().shape({
    device: Yup.string().required("Qurgu tələb olunur."),
  });

  const onPostFinger = (values, resetForm, setSubmitting) => {
    setIsLoading(true);

    const finger = {
      device: values.device,
      finger: Number(currentRadioValue),
      hand: value === 0 ? "LEFT_HAND" : value === 1 && "RIGHT_HAND",
    };
    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}employee/finger/complete/${chooseSapId}`,
      data: finger,
    })
      .then((res) => {
        onSaps(orderBy, sortField, skip, take, filterInputs);
        setSubmitting(false);
        resetForm();
        onHide(false);
        setIsLoading(false);
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined"
            ? err.response.data.message
            : err.message;
        setIsError(message);
        setIsLoading(false);
      });
  };

  const onPostRegister = (resetForm, setSubmitting) => {
    setIsLoadingRegister(true);
    axios({
      method: "post",
      url: `${
        process.env.REACT_APP_API_URL
      }employee/register-fingerprint?deviceId=${
        deviceOption?.value
      }&pin=${chooseSapId}&fingerIndex=${Number(currentRadioValue)}`,
    })
      .then((res) => {
        onSaps(orderBy, sortField, skip, take, filterInputs);
        onHide(false);
        setIsLoadingRegister(false);
      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined"
            ? err.response.data.message
            : err.message;
        setIsError(message);
        setIsLoading(false);
      });
  };
  const formik = useFormik({
    initialValues,
    validationSchema: CreateSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostFinger(values, resetForm, setSubmitting);
    },
  });

  function handleChangeDevice(value) {
    setDeviceOption(value);
    formik.setFieldValue("device", value.label);
  }

  const resetForm = () => {
    onHide();
    formik.resetForm();
  };

  useEffect(() => {
    setIsError("");
    if (!show) {
      setDeviceOption("");
      setCurrentRadioValue();
    }
  }, [show]);

  return (
    <Modal
      size="xl"
      aria-labelledby="create"
      centered
      className="modal pr-0"
      show={show}
      onHide={resetForm}
    >
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="create">Əlavə et</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12 col-md-4 col-lg-4">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <input
                    type="text"
                    name="device"
                    hidden
                    {...formik.getFieldProps("device")}
                  />

                  <ReactSelect
                    suggestions={deviceId}
                    handleChangeSingle={handleChangeDevice}
                    single={deviceOption}
                    label="Qurğu  seçin"
                    placeholder="Qurğu  seçin"
                    inputId="device"
                  />
                </div>
                {formik.touched.device && formik.errors.device ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.device}</div>
                  </div>
                ) : null}
              </div>

              <div className="col-12 pl-4 pr-4 mt-5">
                <AppBar position="static">
                  <Tabs value={value} onChange={handleChange}>
                    <Tab label="Sol əl" />
                    <Tab label="Sağ əl" />
                  </Tabs>
                </AppBar>
                {value === 0 && (
                  <TabContainer>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-12 d-flex  flex-column">
                        <FormControl
                          style={{ marginTop: "45px" }}
                          className="w-100"
                        >
                          <RadioGroup
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            className="w-100"
                          >
                            <FormControlLabel
                              control={
                                <Radio
                                  id="finger"
                                  name="finger"
                                  type="radio"
                                  value="4"
                                  checked={
                                    currentRadioValue === "4" ? true : false
                                  }
                                  onChange={handleRadioChange}
                                />
                              }
                              label="Baş barmaq"
                              className="RadioBtn"
                            />
                            <FormControlLabel
                              control={
                                <Radio
                                  id="finger"
                                  name="finger"
                                  type="radio"
                                  value="3"
                                  checked={
                                    currentRadioValue === "3" ? true : false
                                  }
                                  onChange={handleRadioChange}
                                />
                              }
                              label="Şəhadət barmağı"
                              className="RadioBtn"
                            />
                            <FormControlLabel
                              control={
                                <Radio
                                  id="finger"
                                  name="finger"
                                  type="radio"
                                  value="2"
                                  checked={
                                    currentRadioValue === "2" ? true : false
                                  }
                                  onChange={handleRadioChange}
                                />
                              }
                              label="Orta barmaq"
                              className="RadioBtn"
                            />

                            <FormControlLabel
                              control={
                                <Radio
                                  id="finger"
                                  name="finger"
                                  type="radio"
                                  value="1"
                                  checked={
                                    currentRadioValue === "1" ? true : false
                                  }
                                  onChange={handleRadioChange}
                                />
                              }
                              label="Adsız barmaq"
                              className="RadioBtn"
                            />
                            <FormControlLabel
                              control={
                                <Radio
                                  id="finger"
                                  name="finger"
                                  type="radio"
                                  value="0"
                                  checked={
                                    currentRadioValue === "0" ? true : false
                                  }
                                  onChange={handleRadioChange}
                                />
                              }
                              label="Çeçele barmaq"
                              className="RadioBtn"
                            />
                          </RadioGroup>
                        </FormControl>
                        <div>
                          {/* {formik.touched.finger && formik.errors.finger ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {formik.errors.finger}
                            </div>
                          </div>
                        ) : null} */}
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="body-position d-flex justify-content-center">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/fingericon/left_hand.svg"
                            )}
                          />

                          <div
                            onClick={handleRadioChange4}
                            className="finger"
                            style={{
                              position: "absolute",
                              top: "43%",
                              marginLeft: "-295px",
                              cursor: "pointer",
                            }}
                          >
                            {currentRadioValue === 4 ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/selected.yellow.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : fingerList?.some(
                                (element) => element.finger === 4
                              ) ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/green.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : (
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/fingericon/selectable_finger.svg"
                                )}
                              />
                            )}
                          </div>
                          <div
                            className="finger"
                            onClick={handleRadioChange3}
                            style={{
                              position: "absolute",
                              top: "6%",
                              marginLeft: "-156px",
                              cursor: "pointer",
                            }}
                          >
                            {currentRadioValue === 3 ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/selected.yellow.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : fingerList?.some(
                                (element) => element.finger === 3
                              ) ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/green.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : (
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/fingericon/selectable_finger.svg"
                                )}
                              />
                            )}
                          </div>
                          <div
                            onClick={handleRadioChange2}
                            className="finger"
                            style={{
                              position: "absolute",
                              top: "-1%",
                              marginLeft: "20px",
                              cursor: "pointer",
                            }}
                          >
                            {currentRadioValue === 2 ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/selected.yellow.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : fingerList?.some(
                                (element) => element.finger === 2
                              ) ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/green.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : (
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/fingericon/selectable_finger.svg"
                                )}
                              />
                            )}
                          </div>
                          <div
                            className="finger"
                            onClick={handleRadioChange1}
                            style={{
                              position: "absolute",
                              top: "5%",
                              marginLeft: "215px",
                              cursor: "pointer",
                            }}
                          >
                            {currentRadioValue === 1 ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/selected.yellow.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : fingerList?.some(
                                (element) => element.finger === 1
                              ) ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/green.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : (
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/fingericon/selectable_finger.svg"
                                )}
                              />
                            )}
                          </div>
                          <div
                            onClick={handleRadioChange0}
                            className="finger"
                            style={{
                              position: "absolute",
                              top: "20%",
                              marginLeft: "315px",
                              cursor: "pointer",
                            }}
                          >
                            {currentRadioValue === 0 ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/selected.yellow.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : fingerList?.some(
                                (element) => element.finger === 0
                              ) ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/green.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : (
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/fingericon/selectable_finger.svg"
                                )}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabContainer>
                )}
                {value === 1 && (
                  <TabContainer>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-12 d-flex  flex-column">
                        <FormControl
                          style={{ marginTop: "45px" }}
                          className="w-100"
                        >
                          <RadioGroup
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            className="w-100"
                          >
                            <FormControlLabel
                              control={
                                <Radio
                                  id="finger"
                                  name="finger"
                                  type="radio"
                                  value="5"
                                  checked={
                                    currentRadioValue === "5" ? true : false
                                  }
                                  onChange={handleRadioChange}
                                />
                              }
                              label="Baş barmaq"
                              className="RadioBtn"
                            />
                            <FormControlLabel
                              control={
                                <Radio
                                  id="finger"
                                  name="finger"
                                  type="radio"
                                  value="6"
                                  checked={
                                    currentRadioValue === "6" ? true : false
                                  }
                                  onChange={handleRadioChange}
                                />
                              }
                              label="Şəhadət barmağı"
                              className="RadioBtn"
                            />
                            <FormControlLabel
                              control={
                                <Radio
                                  id="finger"
                                  name="finger"
                                  type="radio"
                                  value="7"
                                  checked={
                                    currentRadioValue === "7" ? true : false
                                  }
                                  onChange={handleRadioChange}
                                />
                              }
                              label="Orta barmaq"
                              className="RadioBtn"
                            />

                            <FormControlLabel
                              control={
                                <Radio
                                  id="finger"
                                  name="finger"
                                  type="radio"
                                  value="8"
                                  checked={
                                    currentRadioValue === "8" ? true : false
                                  }
                                  onChange={handleRadioChange}
                                />
                              }
                              label="Adsız barmaq"
                              className="RadioBtn"
                            />
                            <FormControlLabel
                              control={
                                <Radio
                                  id="finger"
                                  name="finger"
                                  type="radio"
                                  value="9"
                                  checked={
                                    currentRadioValue === "9" ? true : false
                                  }
                                  onChange={handleRadioChange}
                                />
                              }
                              label="Çeçele barmaq"
                              className="RadioBtn"
                            />
                          </RadioGroup>
                        </FormControl>
                        <div></div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="body-position d-flex justify-content-center">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/fingericon/left_hand.svg"
                            )}
                          />
                          <div
                            onClick={handleRadioChange5}
                            className="finger"
                            style={{
                              position: "absolute",
                              top: "43%",
                              marginLeft: "-295px",
                              cursor: "pointer",
                            }}
                          >
                            {currentRadioValue === 5 ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/selected.yellow.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : fingerList?.some(
                                (element) => element.finger === 5
                              ) ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/green.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : (
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/fingericon/selectable_finger.svg"
                                )}
                              />
                            )}
                          </div>
                          <div
                            onClick={handleRadioChange6}
                            className="finger"
                            style={{
                              position: "absolute",
                              top: "6%",
                              marginLeft: "-156px",
                              cursor: "pointer",
                            }}
                          >
                            {currentRadioValue === 6 ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/selected.yellow.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : fingerList?.some(
                                (element) => element.finger === 6
                              ) ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/green.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : (
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/fingericon/selectable_finger.svg"
                                )}
                              />
                            )}
                          </div>
                          <div
                            className="finger"
                            onClick={handleRadioChange7}
                            style={{
                              position: "absolute",
                              top: "-1%",
                              marginLeft: "20px",
                              cursor: "pointer",
                            }}
                          >
                            {currentRadioValue === 7 ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/selected.yellow.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : fingerList?.some(
                                (element) => element.finger === 7
                              ) ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/green.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : (
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/fingericon/selectable_finger.svg"
                                )}
                              />
                            )}
                          </div>
                          <div
                            onClick={handleRadioChange8}
                            className="finger"
                            style={{
                              position: "absolute",
                              top: "5%",
                              marginLeft: "215px",
                              cursor: "pointer",
                            }}
                          >
                            {currentRadioValue === 8 ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/selected.yellow.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : fingerList?.some(
                                (element) => element.finger === 8
                              ) ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/green.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : (
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/fingericon/selectable_finger.svg"
                                )}
                              />
                            )}{" "}
                          </div>
                          <div
                            onClick={handleRadioChange9}
                            className="finger"
                            style={{
                              position: "absolute",
                              top: "20%",
                              marginLeft: "315px",
                              cursor: "pointer",
                            }}
                          >
                            {currentRadioValue === 9 ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/selected.yellow.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : fingerList?.some(
                                (element) => element.finger === 9
                              ) ? (
                              <div
                                style={{
                                  position: "relative",
                                }}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/fingericon/selected.svg"
                                  )}
                                  style={{
                                    position: "absolute",
                                    marginTop: "15px",
                                    marginLeft: "15px",
                                  }}
                                />

                                <img
                                  src="/media/svg/fingericon/green.png"
                                  alt=""
                                  style={{
                                    width: "65px",
                                  }}
                                />
                              </div>
                            ) : (
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/fingericon/selectable_finger.svg"
                                )}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabContainer>
                )}
              </div>
            </div>
            {isError && (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block MuiFormLabel-root Mui-error">
                  {isError}
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            <Button
              type="button"
              className="px-9 mr-5"
              disabled={!formik.values.device || !currentRadioValue}
              onClick={onPostRegister}
            >
              Qeydiyyat et
              {isLoadingRegister && (
                <span className="ml-3 spinner spinner-white"></span>
              )}
            </Button>

            <Button type="submit" className={isLoading ? "px-9" : ""}>
              <span>Əlavə et</span>
              {isLoading && (
                <span className="ml-3 spinner spinner-white"></span>
              )}
            </Button>
          </div>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
